import * as React from 'react';

export const EgressPanelIcon: React.FC = () => (
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="18"
  height="18"
  fill="none"
  stroke="currentColor"
  strokeWidth="1.75"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  {/* Container */}
  <path d="M5 3h14v3" />
  <path d="M19 18v3H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" />

  {/* Arrow partly outside */}
  <path d="M9 12h10" />
  <path d="M15 8l4 4-4 4" />
</svg>
);
